(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exp-contact-form-address"] && !Shopify.designMode) return;
  try {
    
  // Track page load time for anti-spam submit_time
  window.__contactFormLoadTime = Date.now();

  document.addEventListener('DOMContentLoaded', function () {
    const sfForm = document.getElementById('sf-contact-form');
    if (!sfForm) return;

    // Proxy URL is read from a data attribute set by the section settings.
    const PROXY_URL = (sfForm.dataset.proxyUrl || '').replace(/\/$/, '');

    sfForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      const submitBtn = document.getElementById('contact-submit-btn');
      const successMsg = document.getElementById('contact-form-success');
      const spamError = document.getElementById('contact-form-spam-error');

      // Hide previous messages
      if (successMsg) successMsg.style.display = 'none';
      if (spamError) spamError.style.display = 'none';

      // Loading state
      const originalBtnText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      submitBtn.style.opacity = '0.7';

      try {
        // Collect all form data
        const formDataObj = {};
        const formData = new FormData(sfForm);
        for (const [key, value] of formData.entries()) {
          formDataObj[key] = value;
        }

        // Add retURL for Salesforce
        formDataObj.retURL = window.location.origin + window.location.pathname;

        // Calculate submit time (seconds since page load)
        const submitTime = Math.round((Date.now() - window.__contactFormLoadTime) / 1000);

        const payload = {
          // Mark this as a Torontech request for the multi-tenant proxy.
          IS_TORONTECH: true,
          tenant: 'torontech',
          formData: formDataObj,
          senderEmail: formDataObj.email || '',
          senderName: (formDataObj.first_name || '') + ' ' + (formDataObj.last_name || ''),
          message: formDataObj.description || '',
          submitTime: submitTime,
        };

        const response = await fetch(PROXY_URL + '/api/webhook/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result.success) {
          if (successMsg) {
            successMsg.style.display = 'flex';
            successMsg.focus();
          }
          sfForm.reset();
        } else {
          // Generic error (also used for silently-handled spam)
          if (spamError) {
            spamError.style.display = 'flex';
            spamError.focus();
          }
        }
      } catch (err) {
        console.error('Form submission error:', err);
        if (spamError) {
          spamError.style.display = 'flex';
          spamError.focus();
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
        submitBtn.style.opacity = '1';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
